var overlayBg = document.querySelector('.js-overlay-bg');

var menuBtn = document.querySelector('.js-menu-btn');
var menuOverlay = document.querySelector('.js-menu-overlay');
var subMenuOverlays = document.querySelectorAll('.js-submenu-overlay');
var hasChildBtns = document.querySelectorAll('.js-nav-has-child');
var backBtns = document.querySelectorAll('.js-back-btn');
var level1Links = document.querySelectorAll('.js-nav-level-1');
var firstLevel1Link = level1Links[0];
var lastLevel1Link = level1Links[level1Links.length - 1];
var userLink = document.querySelector('.js-user-link');

var searchBtns = document.querySelectorAll('.js-search-btn');
var searchOverlay = document.querySelector('.js-search-overlay');
var closeSearchButton = document.querySelector('.js-close-search');
var searchFocusableItems = null;
if (searchOverlay) {
    searchFocusableItems = searchOverlay.querySelectorAll(':scope input, :scope a');
}
var searchInput = document.getElementById('search-text')
var mobileSearchBtn = document.querySelector('.js-search-btn-mobile');
var desktopSearchBtn = document.querySelector('.js-search-btn-desktop');

var activeOverlay = null;

if (!isDeviceMobile) {
    level1Links.forEach(level1Link => {
        level1Link.setAttribute('tabindex', '0');
        level1Link.setAttribute('aria-expanded', 'false');
        level1Link.removeAttribute('aria-haspopup')
    })
    if (menuOverlay) {
        menuOverlay.removeAttribute('aria-modal');
    }
}

function openMenu() {
    menuOverlay.classList.add('open');
    menuBtn.classList.add('active');
    level1Links.forEach(level1Link => {
        level1Link.setAttribute('tabindex', '0');
    })
    if (userLink) {
        userLink.setAttribute('tabindex', '0');
    }
    if (searchOverlay.classList.contains('open')) {
        closeSearch()
    }
    body.classList.add('no-scroll');
}

function closeMenu() {
    menuBtn.classList.remove('active');
    subMenuOverlays.forEach(subMenuOverlay => {
        if (subMenuOverlay.classList.contains('open')) {
            closeSubMenu(subMenuOverlay);
        }
    })

    if (isDeviceMobile) {
        level1Links.forEach(level1Link => {
            level1Link.setAttribute('tabindex', '-1');
        })
        if (userLink) {
            userLink.setAttribute('tabindex', '-1');
        }
        menuBtn.focus();
        body.classList.remove('no-scroll');
    }

    menuOverlay.classList.remove('open');
}

function openSubMenu(subMenu) {
    subMenuOverlays.forEach(subMenuOverlay => {
        if (subMenuOverlay.classList.contains('open')) {
            closeSubMenu(subMenuOverlay);
        }
    })

    subMenu.classList.add('open');

    var parentBtn = document.querySelector('.js-nav-has-child[aria-controls="' + subMenu.getAttribute('id') + '"]')
    if (parentBtn) {
        parentBtn.classList.add('active');
        parentBtn.setAttribute('tabindex', '0');
    }

    var links = subMenu.querySelectorAll('a:not(.js-link-button)')
    links.forEach(link => {
        link.setAttribute('tabindex', '0')
    })

    if (isDeviceMobile) {
        var back = subMenu.querySelector('.js-back-btn');
        if (back) {
            back.setAttribute('tabindex', '0')
            back.focus()
        }
        level1Links.forEach(level1Link => {
            level1Link.setAttribute('tabindex', '-1');
        })
    } else {
        parentBtn.setAttribute('aria-expanded', 'true');
    }
    activeOverlay = subMenu;
}

function closeSubMenu(subMenu) {
    subMenu.classList.remove('open')

    var parentBtn = document.querySelector('.js-nav-has-child[aria-controls="' + subMenu.getAttribute('id') + '"]')
    if (parentBtn) {
        parentBtn.classList.remove('active');
    }

    var links = subMenu.querySelectorAll('a:not(.js-link-button)')
    links.forEach(link => {
        link.setAttribute('tabindex', '-1')
    })

    if (isDeviceMobile) {
        var back = subMenu.querySelector('.js-back-btn');
        if (back) {
            back.setAttribute('tabindex', '-1')
        }
        level1Links.forEach(level1Link => {
            level1Link.setAttribute('tabindex', '0');
        })

        var parentLink = menuOverlay.querySelector('.js-nav-has-child[aria-controls="' + subMenu.getAttribute('id') + '"]');
        parentLink.focus()
    } else {
        parentBtn.setAttribute('aria-expanded', 'false');
    }

    activeOverlay = null;
}

// Ouverture / fermeture du menu
if (menuBtn) {
    menuBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (menuOverlay.classList.contains('open')) {
            closeMenu();
        } else {
            openMenu()
        }
    })
}

// Ouverture / fermeture des sous-menus
hasChildBtns.forEach((hasChildBtn) => {
    hasChildBtn.addEventListener('click', (e) => {
        e.preventDefault();
        var subMenu = document.getElementById(hasChildBtn.getAttribute('aria-controls'))
        if (subMenu) {
            if (subMenu.classList.contains('open')) {
                closeSubMenu(subMenu)
            } else {
                openSubMenu(subMenu);
            }
        }
    })
})

// Fermeture des sous-menus
backBtns.forEach((backBtn) => {
    backBtn.addEventListener('click', (e) => {
        e.preventDefault();
        var subMenu = document.getElementById(backBtn.getAttribute('aria-controls'))
        if (subMenu) {
            closeSubMenu(subMenu);
        }
    })
})

// Loop de la tabulation
if (header) {
    header.addEventListener('keydown', (e) => {
        if (isDeviceMobile) {
            if (e.key === 'Tab') {
                if (!e.shiftKey) {
                    if (menuOverlay.classList.contains('open') && !activeOverlay && document.activeElement === menuBtn) {
                        e.preventDefault();
                        firstLevel1Link.focus();
                    } else if (document.activeElement === lastLevel1Link && !userLink) {
                        e.preventDefault();
                        menuBtn.focus();
                    } else if (userLink && document.activeElement === userLink) {
                        e.preventDefault();
                        menuBtn.focus();
                    } else if (activeOverlay) {
                        var activeOverlayLinks = activeOverlay.querySelectorAll('a');
                        if (document.activeElement === activeOverlayLinks[activeOverlayLinks.length - 1]) {
                            e.preventDefault();
                            menuBtn.focus();
                        } else if (document.activeElement === menuBtn) {
                            e.preventDefault();
                            var back = activeOverlay.querySelector('.js-back-btn');
                            back.focus();
                        }
                    } else if (searchOverlay.classList.contains('open') && document.activeElement === mobileSearchBtn) {
                        e.preventDefault();
                        searchFocusableItems[0].focus();
                    }
                } else {
                    if (menuOverlay.classList.contains('open') && !activeOverlay && document.activeElement === menuBtn) {
                        e.preventDefault();
                        if (userLink) {
                            userLink.focus();
                        } else {
                            lastLevel1Link.focus()
                        }
                    } else if (document.activeElement === firstLevel1Link) {
                        e.preventDefault();
                        menuBtn.focus();
                    } else if (activeOverlay) {
                        var activeOverlayLinks = activeOverlay.querySelectorAll('a');
                        var back = activeOverlay.querySelector('.js-back-btn');
                        if (document.activeElement === back) {
                            e.preventDefault();
                            menuBtn.focus();
                        } else if (document.activeElement === menuBtn) {
                            e.preventDefault();
                            activeOverlayLinks[activeOverlayLinks.length - 1].focus()
                        }
                    } else if (document.activeElement === mobileSearchBtn && searchOverlay.classList.contains('open')) {
                        e.preventDefault();
                        searchFocusableItems[searchFocusableItems.length - 1].focus();
                    }
                }
            }
        } else {
            if (e.key === 'Tab') {
                if (!e.shiftKey) {
                    if (activeOverlay) {
                        var activeOverlayLinks = activeOverlay.querySelectorAll('a');
                        if (document.activeElement === activeOverlayLinks[activeOverlayLinks.length - 1]) {
                            e.preventDefault();
                            var parentLink = menuOverlay.querySelector('.js-nav-has-child[aria-controls="' + activeOverlay.getAttribute('id') + '"]');
                            parentLink.focus();
                        }
                    }
                } else {
                    if (activeOverlay) {
                        var parentLink = menuOverlay.querySelector('.js-nav-has-child[aria-controls="' + activeOverlay.getAttribute('id') + '"]');
                        if (document.activeElement === parentLink) {
                            e.preventDefault();
                            var activeOverlayLinks = activeOverlay.querySelectorAll('a');
                            activeOverlayLinks[activeOverlayLinks.length - 1].focus()
                        }
                    }
                }
            }
        }
    })
}

function openOverlayBg() {
    if (!overlayBg.classList.contains('show')) {
        overlayBg.classList.add('show');
    }
}

function closeOverlayBg() {
    if (overlayBg.classList.contains('show')) {
        overlayBg.classList.remove('show');
    }
}

function openSearch() {
    closeMenu();
    searchOverlay.classList.add('open');
    openOverlayBg();
    body.classList.add('no-scroll');
    searchBtns.forEach(searchBtn => {
        searchBtn.classList.add('active');
    })
    searchFocusableItems.forEach(searchFocusableItems => {
        searchFocusableItems.setAttribute('tabindex', '0')
    })
    searchInput.focus()
}

function closeSearch() {
    searchOverlay.classList.remove('open');
    closeOverlayBg();
    body.classList.remove('no-scroll');
    searchBtns.forEach(searchBtn => {
        searchBtn.classList.remove('active');
    })
    searchFocusableItems.forEach(searchFocusableItems => {
        searchFocusableItems.setAttribute('tabindex', '-1')
    })
    if (isDeviceMobile) {
        mobileSearchBtn.focus();
    } else {
        desktopSearchBtn.focus();
    }
}

searchBtns.forEach(searchBtn => {
    searchBtn.addEventListener('click', (e) => {
        if (searchOverlay.classList.contains('open')) {
            closeSearch()
        } else {
            openSearch()
        }
    })
})

if (searchOverlay) {
    searchOverlay.addEventListener('keydown', (e) => {
        if (isDeviceMobile) {
            if (e.key === 'Tab') {
                if (!e.shiftKey) {
                    if (document.activeElement === searchFocusableItems[searchFocusableItems.length - 1]) {
                        e.preventDefault();
                        mobileSearchBtn.focus();
                    }
                } else {
                    if (document.activeElement === searchFocusableItems[0] || document.activeElement.getAttribute('type') === 'radio') {
                        e.preventDefault();
                        mobileSearchBtn.focus();
                    }
                }
            }
        } else {
            if (e.key === 'Tab') {
                if (!e.shiftKey) {
                    if (document.activeElement === searchFocusableItems[searchFocusableItems.length - 1]) {
                        e.preventDefault();
                        closeSearchButton.focus();
                    }
                } else {
                    if (document.activeElement === closeSearchButton) {
                        e.preventDefault();
                        searchFocusableItems[searchFocusableItems.length - 1].focus();
                    }
                }
            }
        }
    })
}

if (closeSearchButton) {
    closeSearchButton.addEventListener('click', (e) => {
        if (searchOverlay.classList.contains('open')) {
            closeSearch()
        }
    })
}

function closeAllOverlays() {
    if (menuOverlay.classList.contains('open')) {
        closeMenu();
    }
    if (searchOverlay.classList.contains('open')) {
        closeSearch();
    }

    var popupVariant = document.getElementById("popup-variant")
    if (popupVariant !== null && popupVariant.classList.contains('open')) {
        popupVariant.classList.remove("open")
        closeOverlayBg();
    }
}

if (overlayBg) {
    overlayBg.addEventListener('click', (e) => {
        closeAllOverlays();
    })
}

if (header) {
    header.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeMenu();
        }
    })
}

if (searchOverlay) {
    searchOverlay.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeSearch();
        }
    })
}

window.addEventListener('resize', (e) => {
    if (!isDeviceMobile) {
        if (menuBtn.classList.contains('open')) {
            closeMenu()
        }
    }
})

var searchForms = document.querySelectorAll('.js-search-form');

searchForms.forEach(searchForm => {
    var searchScopeInputs = searchForm.querySelectorAll('input[name=search-scope]');
    var advancedSearchLink = searchForm.querySelector('.js-advanced-search-link')
    var exactCheckbox = searchForm.querySelector('.js-exact-checkbox')
    var exactSearchCheckbox = searchForm.querySelector('.js-exact-search-checkbox')
    var searchTextInput = searchForm.querySelector('input[name=q]');

    searchScopeInputs.forEach(searchScopeInput => {
        searchScopeInput.addEventListener('change', e => {
            if (searchScopeInput.checked === true) {
                searchForm.dataset.action = searchScopeInput.value;
                if (searchScopeInput.value === "resultats-recherche-avancee") {
                    var placeholder = "Rechercher un film ou une personnalité";
                    if (advancedSearchLink) {
                        advancedSearchLink.style.display = "block";
                    }
                    exactCheckbox.style.display = "block";
                } else {
                    var placeholder = "Rechercher un article…";
                    if (advancedSearchLink) {
                        advancedSearchLink.style.display = "none";
                    }
                    exactSearchCheckbox.checked = false;
                    exactCheckbox.style.display = "none";
                }
                searchTextInput.setAttribute('placeholder', placeholder);
                searchForm.querySelector('label[for=' + searchTextInput.getAttribute('id') + ']').innerText = placeholder;
            }
        })
    })

    searchForm.addEventListener('submit', e => {
        e.preventDefault();

        searchTextInput.setCustomValidity("")
        if (searchTextInput.validity.valueMissing) {
            searchTextInput.setCustomValidity("Veuillez renseigner ce champ.");
        } else if (searchTextInput.validity.patternMismatch) {
            searchTextInput.setCustomValidity("Ce champ ne peut pas contenir uniquement des espaces.");
        }

        if (!searchForm.checkValidity()) {
            searchTextInput.reportValidity();
        } else {
            var newParams = new URLSearchParams();
            if (exactSearchCheckbox.checked) {
                newParams.set('q', `"${searchTextInput.value.trim()}"`)
            } else {
                newParams.set('q', searchTextInput.value.trim())
            }
            window.location.href = "/" + searchForm.dataset.action + "?" + newParams.toString();
        }
    })
})